<template>
  <div class="container_box">
    <Tabs v-model="tabName" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in distributorAuditStatusList" :label="item.name" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003193')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="registrationTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003194')" prop="registerSource" :placeholder="$t('key1003195')">
              <Select v-model="pageParams.registerSource" filterable>
                <Option v-for="item in registerSourceList" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003196')" prop="labelNames">
              <Select v-model="pageParams.labelNames" filterable multiple :placeholder="$t('key1003197')">
                <Option v-for="item in customerLabelList" :value="item.labelName">{{ item.labelName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003104')" prop="distributorMerchantGradeId">
              <Select v-model="pageParams.distributorMerchantGradeId" filterable :placeholder="$t('key1003198')">
                <Option v-for="(item, index) in customerGradeList" :value="item.ymsDistributorMerchantGradeId" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '95px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')" prop="searchValue">
              <Input :placeholder="$t('key1003199')" v-model.trim="pageParams.searchValue"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button
        type="primary"
        class="mr15"
        @click="$refs['addCustomers'].initCustomersData('add')"
        v-if="getPermission('ymsDistributorMerchant_create')">
        {{ $t('key1003202') }}
      </Button>
      <Button
        class="mr15"
        v-if="pageParams.distributorAuditStatus !== 0 && getPermission('ymsDistributorMerchant_mobileGrouping')"
        @click="selectGroupingBtn">
        {{ $t('key1003203') }}
      </Button>
      <Button
        class="mr15"
        v-if="getPermission('ymsDistributorMerchant_configurationTabs')"
        @click="batchConfigLabelBtn">
        {{ $t('key1001441') }}
      </Button>
      <Button
        v-if="['null', 0].includes(pageParams.distributorAuditStatus) && getPermission('ymsDistributorMerchant_approvalPass')"
        class="mr15"
        @click="batchAuditBtn">
        {{ $t('key1003204') }}
      </Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="440"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="getSelectValue">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增客户的弹窗-->
    <addCustomersModal
      ref="addCustomers"
      :showProductWholesaleModel="showProductWholesaleModel"
      @updateData="pageParamsStatus = true">
    </addCustomersModal>
    <!--移动分组弹窗-->
    <moveGroupingModal ref="moveGrouping" :moveGroupingList="moveGroupingList" @updateData="updateData"></moveGroupingModal>
    <!--批量配置标签弹窗-->
    <batchConfigLabelModal configurationType="customer" ref="batchConfigLabel" @updateData="updateData"></batchConfigLabelModal>
    <!--客户详情-->
    <customerDetailsDrawer
      ref="customerDetails"
      :showProductWholesaleModel="showProductWholesaleModel"
      :customerGradeList="customerGradeList"
      @updateData="pageParamsStatus = true">
    </customerDetailsDrawer>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG']">
      <h2 class="mb10">{{ $t('key1003200') + businessOrderNumber + $t('key1003201') }}</h2>
    </commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import addCustomersModal from "@/views/yms/components/customerManage/addCustomersModal.vue";
import dropDownFilter from "@/components/common/dropDownFilter";
import moveGroupingModal from "@/views/yms/components/customerManage/moveGroupingModal.vue";
import batchConfigLabelModal from "@/components/common/batchConfigLabelModal.vue";
import customerDetailsDrawer from "@/views/yms/components/customerManage/customerDetailsDrawer.vue";
import commonLogModal from "@/components/common/commonLogModal.vue";
import {getCustomerLevelAll, getDataSetBatchList, getEnumList, getEnumName, commonLocalStorage} from "@/utils/common";

export default {
  name: 'customerList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      registrationTime: [],
      pageParams: {
        registerStartTime: null,
        registerEndTime: null,
        registerSource: 0,
        distributorAuditStatus: 'null',
        ymsMerchantIds: '', // 客户编号
        mobiles: '', // 手机号
        emails: '', // 邮箱
        searchValue: '',
        labelNames: [], // 客户标签
        distributorMerchantGradeId: null, // 客户等级
        distributorMerchantGroupId: null, // 客户分组
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableData: [],
      tableColumns: [],
      selectTableData: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003173'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003174'), parameterKey: 'ymsMerchantIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002807'), parameterKey: 'mobiles'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002808'), parameterKey: 'emails'}
      ],
      defaultSelectValue: 1,
      distributorAuditStatusList: [],
      customerLabelList: [],
      customerGradeList: [],
      moveGroupingList: [],
      tabName: '1',
      businessOrderNumber: null,
      enumData: []
    };
  },
  computed: {
    // 批发模式
    showProductWholesaleModel() {
      const obj = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(obj?.productWholesaleModelSaas) === 1;
    },
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
      return parameterKeyList;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 注册来源
    registerSourceList() {
      const ENUM_KEY = 'YmsMerchantRegisterSourceCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 0,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        let enumKeyList = [
          'YmsMerchantRegisterSourceCoreEnum',
          'YmsDistributorMerchantDetailDistributorTypeCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await v.getCustomerGroupData();
        await v.getCustomerLabelData();
        await getCustomerLevelAll().then((data) => {
          v.customerGradeList = v.handleMultilinguaTableFields(data, ['name']);
        });
        await v.search();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.registrationTime = [];
      v.resetDate();
      v.changeInput(1);
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      let keyList = ['distributorAuditStatus'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
      }
      params.registerSource = v.pageParams.registerSource === 0 ? null : v.pageParams.registerSource;
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      v.handleColumns();
      if (v.getPermission('ymsDistributorMerchant_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributorMerchant_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.updateTableDom('selection');
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取注册时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.registerStartTime = null;
          v.pageParams.registerEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registrationTime = v.defaultTimePeriod(value, false);
          v.pageParams.registerStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.registerEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置注册时间
    resetDate() {
      this.pageParams.registerStartTime = null;
      this.pageParams.registerEndTime = null;
    },
    // 停用客户
    stopUsingBtn(ymsMerchantId, status) {
      let v = this;
      let apiUrl = status === 1
        ? api.put_ymsDistributorMerchant_disable
        : api.put_ymsDistributorMerchant_enable;
      let title = status === 0
        ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003175')
        : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003176');
      v.$Modal.confirm({
        title: title,
        onOk: () => {
          v.axios.put(apiUrl + `${ymsMerchantId}`, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 获取列表勾选的数据
    getSelectValue(value) {
      this.selectTableData = value;
    },
    // 批量审核
    batchAuditBtn() {
      let v = this;
      let ymsMerchantIds = [];
      if (v.selectTableData.length > 0) {
        let talg = v.selectTableData.every((item) => {
          let distributorAuditStatus = item.ymsDistributorMerchantDetail.distributorAuditStatus; // 1 已审核  0待审核
          return distributorAuditStatus === 1
        });
        if (talg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003177'));
          return false;
        } else {
          v.selectTableData.map((item) => {
            let distributorAuditStatus = item.ymsDistributorMerchantDetail.distributorAuditStatus;
            if (distributorAuditStatus === 0) {
              ymsMerchantIds.push(item.ymsMerchantId);
            }
          });
        }
        v.axios.put(api.put_ymsDistributorMerchant_approvalPass, ymsMerchantIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002694'));
            v.selectTableData = [];
            v.$refs['selection'].selectAll(false);
            v.pageParamsStatus = true;
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003178'));
        return false;
      }
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 获取客户分组数据
    getCustomerGroupData() {
      let v = this;
      let list = [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 1, distributorMerchantGroupId: null, distributorAuditStatus: 'null'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002944'), value: 2, distributorMerchantGroupId: null, distributorAuditStatus: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003179'), value: 3, distributorMerchantGroupId: null, distributorAuditStatus: 1},
      ];
      v.moveGroupingList = [];
      v.axios.get(api.get_ymsMerchantGroup_queryTabGroupName).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.moveGroupingList = data;
            let newData = JSON.parse(JSON.stringify(data));
            newData.map((item, index) => {
              list.push({
                value: index + 4,
                name: item.groupName,
                distributorAuditStatus: 1,
                distributorMerchantGroupId: item.ymsMerchantGroupId
              })
            });
          }
          v.distributorAuditStatusList = list;
        }
      });
    },
    // 获取客户标签数据
    getCustomerLabelData() {
      let v = this;
      v.customerLabelList = [];
      v.axios.get(api.get_ymsDistributorLabel_list).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.customerLabelList = data;
        }
      });
    },
    // 处理列表Columns字段
    handleColumns() {
      let v = this;
      let distributorAuditStatus = v.pageParams.distributorAuditStatus;
      let hideKeyList = [];
      let columns = [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'left',
          fixed: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003173'),
          key: 'ymsMerchantId',
          minWidth: 100,
          align: 'left',
          fixed: 'left',
          render(h, params) {
            let ymsMerchantId = params.row.ymsMerchantId;
            return h('Alink', {
              props: {
                AlinkShow: v.getPermission('ymsDistributorMerchant_detail'),
                linkName: ymsMerchantId,
                styles: {
                  justifyContent: 'flex-start'
                }
              },
              on: {
                AlinkBtn: () => {
                  v.$refs['customerDetails'].initCustomerDetailsData('look', ymsMerchantId, true);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003180'),
          key: 'name',
          minWidth: 150,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003181'),
          key: 'distributorMerchantGroupName',
          minWidth: 140,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003182'),
          key: 'labelNames',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let labelNames = params.row.labelNames || [];
            let text = '';
            if (labelNames.length > 0) {
              text = labelNames.join('<br/>');
            }
            return h('div', {
              class: 'mt4 mb4',
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003183'),
          key: 'distributorMerchantGradeName',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let text = params.row.distributorMerchantGradeName || '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003184'),
          key: 'distributorType',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let distributorType = params.row.ymsDistributorMerchantDetail?.distributorType;
            let text = getEnumName(v.enumData, 'YmsDistributorMerchantDetailDistributorTypeCoreEnum', distributorType);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003185'),
          key: 'currency',
          minWidth: 100,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            return h('span', currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002811'),
          key: 'contacts',
          minWidth: 140,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002812'),
          key: 'mobile',
          minWidth: 140,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002813'),
          key: 'phone',
          minWidth: 140,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'),
          key: 'email',
          align: 'left',
          minWidth: 180,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003186'),
          key: 'balance',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let balance = params.row.balance;
            return h('div', [
              h('div', v.formatCurrency(balance)),
              h('div', '(' + currency + ')')
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003187'),
          key: 'withholdingAmount',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let withholdingAmount = params.row.withholdingAmount;
            return withholdingAmount > 0 ? h('div', [
              h('div', v.formatCurrency(withholdingAmount)),
              h('div', '(' + currency + ')')
            ]) : withholdingAmount === 0 ? h('div', [
              h('div', 0),
              h('div', '(' + currency + ')')
            ]) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003188'),
          key: 'distributorInitialQuota',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let distributorInitialQuota = params.row.distributorInitialQuota;
            return distributorInitialQuota > 0 ? h('div', [
              h('div', v.formatCurrency(distributorInitialQuota)),
              h('div', '(' + currency + ')')
            ]) : distributorInitialQuota === 0 ? h('div', [
              h('div', 0),
              h('div', '(' + currency + ')')
            ]) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003189'),
          key: 'distributorUsedQuota',
          align: 'left',
          minWidth: 130,
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let distributorUsedQuota = params.row.distributorUsedQuota;
            return distributorUsedQuota > 0 ? h('div', [
              h('div', v.formatCurrency(distributorUsedQuota)),
              h('div', '(' + currency + ')')
            ]) : distributorUsedQuota === 0 ? h('div', [
              h('div', 0),
              h('div', '(' + currency + ')')
            ]) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003190'),
          key: 'registerSource',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let registerSource = params.row.registerSource;
            let obj = v.registerSourceList.filter(i => registerSource === i.value);
            let text = obj.length ? obj[0].title : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002815'),
          key: 'createdTime',
          align: 'left',
          sortable: true,
          width: 170,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'distributorStatus',
          align: 'left',
          width: 100,
          render: (h, params) => {
            let status = params.row.distributorStatus === 1;
            let statusText = status ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463');
            return h('div', {
              style: {color: status ? 'green' : 'red'}
            }, statusText);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003191'),
          key: 'remark',
          width: 200,
          align: 'left',
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remark, 200, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 220,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            let status = params.row.distributorStatus;
            let ymsMerchantId = params.row.ymsMerchantId;
            let distributorAuditStatus = v.pageParams.distributorAuditStatus !== 0;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsDistributorMerchant_detail'),
                    clickFn: () => {
                      v.$refs['customerDetails'].initCustomerDetailsData('look', ymsMerchantId, true);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: distributorAuditStatus && v.getPermission('ymsDistributorMerchant_update'),
                    clickFn: () => {
                      v.$refs['customerDetails'].initCustomerDetailsData('edit', ymsMerchantId, true);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: distributorAuditStatus && v.getPermission('ymsDistributorMerchant_enable') && status !== 1,
                    clickFn: () => {
                      v.stopUsingBtn(ymsMerchantId, status);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    color: '#FF0000',
                    show: distributorAuditStatus && v.getPermission('ymsDistributorMerchant_disable') && status === 1,
                    clickFn: () => {
                      v.stopUsingBtn(ymsMerchantId, status);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.businessOrderNumber = ymsMerchantId;
                      v.$refs['commonLog'].initCommonLogData(ymsMerchantId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      if (distributorAuditStatus !== 'null') {
        hideKeyList = ['distributorMerchantGroupName'];
      }
      if (distributorAuditStatus === 0) {
        hideKeyList = ['distributorMerchantGroupName', 'balance', 'withholdingAmount'];
      }
      if (!v.showProductWholesaleModel) {
        hideKeyList.push('distributorType');
      }
      v.tableColumns = columns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.$forceUpdate();
    },
    // 移动分组
    selectGroupingBtn() {
      let v = this;
      if (v.selectTableData.length > 0) {
        v.$refs['moveGrouping'].initMoveGroupingData(v.selectTableData);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003192'));
        return false;
      }
    },
    // 批量配置标签
    batchConfigLabelBtn() {
      let v = this;
      if (v.selectTableData.length > 0) {
        v.$refs['batchConfigLabel'].initBatchConfigLabelData(v.selectTableData, v.customerLabelList);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003192'));
        return false;
      }
    },
    // 切换Tab栏
    changeTab(val) {
      let value = Number(val);
      this.distributorAuditStatusList.map((item) => {
        if (item.value === value) {
          this.pageParams.distributorMerchantGroupId = item.distributorMerchantGroupId;
          this.pageParams.distributorAuditStatus = item.distributorAuditStatus;
          this.pageParams.pageNum = 1;
          this.pageParamsStatus = true;
        }
      })
    },
    // 更新数据
    updateData() {
      this.selectTableData = [];
      this.$refs['selection'].selectAll(false);
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    commonLogModal,
    addCustomersModal,
    dropDownFilter,
    moveGroupingModal,
    batchConfigLabelModal,
    customerDetailsDrawer
  }
};
</script>

<style lang="less" scoped>

</style>
